<template>
  <default>
    <div class="tw-w-full" id="myDiv">
      <bread-crumb :breadcrumbs="breadcrumbs" />
    </div>

    <v-card v-if="!loading" class="tw-mt-5 md:tw-mt-16 tw-pb-10">
      <div class="tw-px-4 md:tw-px-8">
        <card-title icon="mdi-cash">Card payment</card-title>
      </div>
      <div class="tw-flex tw-justify-center tw-px-4 md:tw-px-12 tw-mt-4 md:tw-mt-10">
        <div class="tw-w-full md:tw-w-8/12 tw-flex tw-justify-center tw-flex-col">
          <div class="tw-w-full lg:tw-w-3/4 tw-self-center">
            <div v-if="paymentStatus === 'SUCCESSFUL'" class="tw-bg-green-200 tw-rounded-lg tw-p-4 md:tw-mt-8 c-gray-text tw-mt-4">
              <p><strong>Your Payment was received successfully.</strong> <br>
                Your policy is currently being processed. You will receive a certificate on email. Please print and stick it on your car windscreen. Thank you for choosing us as your preferred insurer. APA, Insuring Happiness</p>

              <div class="tw-mt-4 tw-mt-8 tw-px-4 tw-flex tw-justify-center">
                <v-btn
                    :to="{name: 'MyPolicies'}"
                    color="secondary"
                >View My Policies</v-btn>
              </div>
            </div>
            <div v-if="paymentStatus === 'FAILED'" class="tw-bg-red-200 tw-rounded-lg tw-p-4 md:tw-mt-8 c-gray-text tw-mt-4">
              <p>Your Payment was NOT successful with message <strong>{{msg}}</strong> <br>  You'll be required to retry paying</p>
            </div>
          </div>

          <div v-if="paymentStatus === 'FAILED'" class="tw-mt-4 tw-mt-8 tw-px-4 tw-flex tw-justify-center">
            <v-btn
                color="secondary"
                :to="link"
            >Retry payment Request</v-btn>
          </div>
        </div>
      </div>
    </v-card>
    <div v-else class="tw-w-full tw-flex tw-justify-center">
      <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>
  </default>
</template>

<script>
import BreadCrumb from '@/components/dashboard/BreadCrumb';
import Default from '@/components/layout/Default';
import CardTitle from '@/components/shared/CardTitle';
import axios from 'axios';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { FB_BUY_PAYMENT_CARD, FB_BUY_PAYMENT_FAILURE, FB_BUY_PAYMENT_SUCCESS } from '@/utils/const';

export default {
  name: 'CardRedirectPage',
  components: { CardTitle, Default, BreadCrumb },
  data() {
    return {
      paymentStatus: '',
      link: null,
      msg: '',
      loading: true,
      breadcrumbs: [
        {
          text: 'Card Payment',
          disabled: true,
          to: { name: 'CardRedirect' },
        },
      ],
    };
  },
  computed: {
    ...mapGetters('auth', ['authenticatedUser']),
  },
  metaInfo: {
    title: 'Card Payment Redirect',
  },
  mounted() {
    const { response } = this.$route.query;
    const resp = response ? atob(response) : 'error';
    if ((!this.$route.query.desc && !this.$route.query.accountRef && !this.$route.query.response) || !this.isJson(resp)) {
      this.$router.push({ name: 'Dashboard' });
    } else {
      const quote = this.$route.query.q;
      const benefit = this.$route.query.b;
      if ((!!quote && !!benefit)) {
        this.link = { name: 'BuyCover', query: { q: quote, b: benefit } };
      } else {
        this.link = { name: 'RenewPolicy', params: { policyNo: this.$route.params.policyNo, batchNo: this.$route.params.batchNo } };
      }
      this.validateCardPayment(resp);
    }
  },
  methods: {
    validateCardPayment(response) {
      const resp = JSON.parse(response);
      // eslint-disable-next-line no-prototype-builtins
      if (resp.hasOwnProperty('errors')) {
        this.loading = false;
        this.paymentStatus = 'FAILED';
        this.msg = resp.error.statusMessage;
        // eslint-disable-next-line no-prototype-builtins
      } else if (resp.hasOwnProperty('Validated') && resp.Validated === false) {
        this.loading = false;
        this.paymentStatus = 'FAILED';
        this.msg = resp.ErrorDescription;
      } else {
        const { desc } = this.$route.query;
        const { accountRef } = this.$route.query;
        const { name } = this.authenticatedUser;
        const data = {
          paymentRef: resp.transactionRef,
          amount: parseInt(resp.transactionAmount, 10) / 100,
          transactionReference: accountRef,
          mpesaReceiptNumber: resp.transactionRef,
          transactionDescription: desc,
          paymentDate: moment().format('YYYY-MM-DD HH:mm:ss'),
          paymentMode: 'Card',
          transactionCurrency: 'KES',
          phoneNumber: this.authenticatedUser.phone_number,
          surname: name.split(' ')[0],
          otherName: name,
          provider: resp.provider,
          domain: 'ISWKE',
          merchantId: process.env.VUE_APP_IS_MERCHANT_CODE,
          signature: 'string',
        };
        axios.post('/customer/payment-wallet/payment-gateway-transaction', data).then((result) => {
          this.loading = false;
          if (result.data.success) {
            this.paymentStatus = 'SUCCESSFUL';
            this.$analytics.logEvent(FB_BUY_PAYMENT_CARD);
            this.$analytics.logEvent(FB_BUY_PAYMENT_SUCCESS);
          } else {
            this.paymentStatus = 'FAILED';
            this.$analytics.logEvent(FB_BUY_PAYMENT_FAILURE);
          }
          this.msg = result.data.msg;
        });
      }
    },
    isJson(str) {
      try {
        JSON.parse(str);
      } catch {
        return false;
      }
      return true;
    },
  },
};
</script>
